module.exports = __webpack_public_path__ + "img/war-of-worlds.80058cee.png";